import { REACT_APP_ENV, REACT_APP_VERSION, SENTRY_DSN, BASE_ALOFT_URL } from 'constants/envVars';
import * as Sentry from '@sentry/react';
import React from 'react';
import {
	useLocation,
	useNavigationType,
	createRoutesFromChildren,
	matchRoutes
} from 'react-router-dom';

export const initSentry = () => {
	Sentry.init({
		dsn: SENTRY_DSN,
		environment: REACT_APP_ENV,
		integrations: [
			Sentry.reactRouterV6BrowserTracingIntegration({
				useEffect: React.useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes
			}),
			Sentry.replayIntegration({
				maskAllText: true,
				blockAllMedia: true
			}),
			Sentry.captureConsoleIntegration({ levels: ['error'] }),
			Sentry.httpClientIntegration({
				failedRequestStatusCodes: [[500, 599]],
				failedRequestTargets: BASE_ALOFT_URL ? [BASE_ALOFT_URL] : []
			}),
			Sentry.reportingObserverIntegration(),
			Sentry.extraErrorDataIntegration()
		],
		ignoreErrors: [/^Warning:/],
		maxBreadcrumbs: 100,
		tracesSampleRate: 0.1,
		release: REACT_APP_VERSION,
		normalizeDepth: 3,
		replaysSessionSampleRate: 0,
		replaysOnErrorSampleRate: 0.05
	});
};

export const sentryReduxEnhancer = Sentry.createReduxEnhancer({});
